import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Layout } from "@lubbezposrednio-frontend/commons";
import { Box, Button, Flex, Heading, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FiCheck, FiClock, FiList, FiPlusCircle } from "react-icons/fi";

const BENEFITS = [
  { icon: FiList, text: "Historia wszystkich głosowań, w których brałeś udział" },
  { icon: FiPlusCircle, text: "Organizuj własne głosowania — za darmo" },
  { icon: FiClock, text: "Szybszy udział w kolejnych głosowaniach" }
];

export const VoteConfirmScreen: React.FC = () => {
  useEffect(() => {
    document.title = "Potwierdzenie głosowania";
  }, []);

  return (
    <Layout>
      <Flex flex={1} w="100%" align="center" justify="center" px={{ base: "20px", md: "32px" }} py={{ base: "48px", md: "72px" }}>
        <VStack
          w="100%"
          maxW="560px"
          bg="white"
          borderRadius="24px"
          boxShadow="0 18px 50px rgba(67,0,152,0.10)"
          border="1px solid rgba(67,0,152,0.06)"
          p={{ base: "32px 24px", md: "48px 44px" }}
          spacing="24px"
        >
          <Flex w="76px" h="76px" align="center" justify="center" borderRadius="full" bg="rgba(47,206,37,0.14)">
            <Icon as={FiCheck} boxSize="38px" color="#1f9e18" />
          </Flex>

          <VStack spacing="8px">
            <Heading fontSize={{ base: "26px", md: "30px" }} color="primary" textAlign="center" fontWeight="800">
              Dziękujemy za oddany głos!
            </Heading>
            <Text color="gray.500" textAlign="center" fontSize={{ base: "15px", md: "16px" }}>
              Twój głos został potwierdzony i bezpiecznie zapisany.
            </Text>
          </VStack>

          {/* CTA: załóż konto */}
          <Box w="100%" bgGradient="linear(135deg, #430098 0%, #5a0bbf 100%)" borderRadius="20px" p={{ base: "24px", md: "28px" }} color="white">
            <Heading fontSize={{ base: "19px", md: "21px" }} fontWeight="800" mb="6px">
              Załóż darmowe konto
            </Heading>
            <Text fontSize="14px" color="rgba(255,255,255,0.82)" mb="18px">
              Nie musisz mieć konta, by głosować — ale dzięki niemu zyskujesz:
            </Text>

            <VStack align="stretch" spacing="12px" mb="22px">
              {BENEFITS.map(b => (
                <HStack key={b.text} spacing="12px" align="flex-start">
                  <Flex w="28px" h="28px" align="center" justify="center" borderRadius="9px" bg="rgba(255,255,255,0.14)" flexShrink={0}>
                    <Icon as={b.icon} boxSize="15px" color="white" />
                  </Flex>
                  <Text fontSize="14px" lineHeight="20px" color="rgba(255,255,255,0.92)">
                    {b.text}
                  </Text>
                </HStack>
              ))}
            </VStack>

            <Button
              as={Link}
              to="/rejestracja"
              w="100%"
              h="auto"
              py="14px"
              bg="accent"
              color="white"
              fontSize="16px"
              fontWeight="700"
              borderRadius="13px"
              boxShadow="0 10px 24px rgba(229,31,68,0.35)"
              _hover={{ bg: "#c41a3a" }}
              _active={{ bg: "#a8152f" }}
            >
              Załóż konto za darmo
            </Button>
          </Box>

          <Button as={Link} to="/" variant="ghost" color="primary" fontWeight="600" _hover={{ bg: "rgba(67,0,152,0.05)" }}>
            Wróć na stronę główną
          </Button>
        </VStack>
      </Flex>
    </Layout>
  );
};
